import type { ProductionDeviceSetting, ProductionTableDef } from '@/objects/generated';
import type { ProductionColumnType } from '@/objects/generated/enums/ProductionColumnType';

export class ProductionTableRow {
    public Index: string = '';

    public Bib?: string;

    public Name?: string;

    public TeamClub?: string;

    public Diff?: string;

    public Time?: string;

    public Rank?: string;

    public Points?: string;

    public Meters?: string;

    public Lap?: string;

    public Km?: string;

    public StartingTime?: string;

    public StationRoleName?: string;

    public CategoryName?: string;

    /**
     * Help to identify if the data is coming from SignalR
     */
    public FromSignalR?: boolean;

    constructor(ProductionTableRow?: ProductionTableRow) {
        if (!ProductionTableRow) {
            return;
        }
        this.Index = ProductionTableRow.Index;
        this.Bib = ProductionTableRow.Bib;
        this.Name = ProductionTableRow.Name;
        this.TeamClub = ProductionTableRow.TeamClub;
        this.Diff = ProductionTableRow.Diff;
        this.Time = ProductionTableRow.Time;
        this.Rank = ProductionTableRow.Rank;
        this.Points = ProductionTableRow.Points;
        this.Meters = ProductionTableRow.Meters;
        this.Lap = ProductionTableRow.Lap;
        this.Km = ProductionTableRow.Km;
        this.StartingTime = ProductionTableRow.StartingTime;
        this.StationRoleName = ProductionTableRow.StationRoleName;
        this.CategoryName = ProductionTableRow.CategoryName;
        this.FromSignalR = ProductionTableRow.FromSignalR;
    }

    /**
     * Get the value based on the column
     * @param column
     * @returns
     */
    public GetValue(column: ProductionColumnType): string {
        switch (column) {
            case 'BIB':
                return this.Bib || '';
            case 'NAME':
                return this.Name || '';
            case 'TEAMCLUB':
                return this.TeamClub || '';
            case 'DIFF':
                return this.Diff || '';
            case 'TIME':
                return this.Time || '';
            case 'RANK':
                return this.Rank || '';
            case 'POINTS':
                return this.Points || '';
            case 'METERS':
                return this.Meters || '';
            case 'LAP':
                return this.Lap || '';
            case 'KM':
                return this.Km || '';
            case 'STARTTIME':
                return this.StartingTime || '';
            case 'ROLENAME':
                return this.StationRoleName || '';
            case 'CATEGORY':
                return this.CategoryName || '';
            default:
                return '';
        }
    }

    /**
     * Generate the correct style for the column
     * @param column
     * @param visibleColumns
     * @returns
     */
    public GetStyle(column: ProductionColumnType, visibleColumns: ProductionColumnType[]): string {
        const styles: string[] = [];

        // Check if the column is visible
        if (visibleColumns.indexOf(column) === -1) {
            styles.push('display: none;');
            return styles.join(';');
        }

        // check text alignment
        switch (column) {
            case 'TIME':
            case 'METERS':
            case 'DIFF':
            case 'POINTS':
            case 'STARTTIME':
            case 'KM':
                styles.push('text-align: right;');
                break;
            case 'RANK':
            case 'BIB':
            case 'LAP':
                styles.push('text-align: center;');
                break;
            default:
                styles.push('text-align: left;');
                styles.push('white-space: nowrap;');
                styles.push('text-overflow: ellipsis');
                break;
        }

        return styles.join(';');
    }

    /**
     * Get the correct row styles based on the table and settings
     * @param table
     * @param settings
     * @returns
     */
    public GetRowStyle(table: ProductionTableDef, settings: ProductionDeviceSetting): string {
        const styles: string[] = [];

        if (!this.FromSignalR) {
            return '';
        }

        // Check for fadeout
        if (
            table.DisplayType === 'SCROLL' &&
            settings.RowFadeooutPeriod &&
            settings.RowFadeoutColor &&
            settings.RowFadeoutColor != '#00000000'
        ) {
            styles.push(`animation-name: productionFadeoutBackground`);
            styles.push(`animation-duration: ${settings.RowFadeooutPeriod}ms`);
            styles.push(`animation-delay: 0s`);
            styles.push(`animation-repeat: 1`);
            styles.push(`animation-fill-mode: forwards`);
        }
        return styles.join(';');
    }
}
